module.exports = __webpack_public_path__ + "static/avatar_alexandr_nevskyi@2x-472fd8f4d47020d39fad66aa7beca2b4.jpg";